export var HUYA = HUYA || {};

HUYA.HuYaUdbNotify = function () {
  this.eNotifyType = HUYA.HuYaUdbNotifyType.HUYAUDB_NOTIFYTYPE_LOG;
  this.sMsg = "";
};

HUYA.HuYaUdbNotify.prototype.readFrom = function (is) {
  this.eNotifyType = is.readInt32(0, false, this.eNotifyType);
  this.sMsg = is.readString(1, false, this.sMsg);
};

HUYA.HuYaUdbNotify.prototype.writeTo = function (os) {
  os.writeInt32(0, this.eNotifyType);
  os.writeString(1, this.sMsg);
};

HUYA.HuYaUdbNotify.prototype._clone = function () {
  return new HUYA.HuYaUdbNotify();
};
HUYA.HuYaUdbNotify.prototype._write = function (os, tag, value) {
  os.writeStruct(tag, value);
};
HUYA.HuYaUdbNotify.prototype._read = function (is, tag, def) {
  return is.readStruct(tag, true, def);
};
HUYA.HuYaUdbNotifyType = {
  HUYAUDB_NOTIFYTYPE_LOG: 101,
};
export default HUYA;
